import { Skeleton as MuiSkeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SkeletonBoxProps, SKELETON_ANIMATION } from '../Skeleton.types';
import { getSkeletonBackgroundColor, getSkeletonBorderRadius } from '../styleUtils';

const DEFAULT_WIDTH = '100%';
const DEFAULT_HEIGHT = 40;

export const SkeletonBox = ({
    width = DEFAULT_WIDTH,
    height = DEFAULT_HEIGHT,
    sx,
}: SkeletonBoxProps) => {
    const theme = useTheme();

    return (
        <MuiSkeleton
            variant="rounded"
            width={width}
            height={height}
            animation={SKELETON_ANIMATION}
            sx={{
                backgroundColor: getSkeletonBackgroundColor(theme),
                borderRadius: getSkeletonBorderRadius(theme),
                ...sx,
            }}
        />
    );
};
